import Aside from './aside.element.js';

// export * from "./aside.element.js";
export default Aside;

Aside.define('wje-aside', Aside);
